angular.module('tikonApp').directive('eoScheduler', ['DateUtil', '$mdDialog', '$timeout', function (dateUtil, $mdDialog, $timeout) {
    return {
        restrict: 'A',
        scope: {timingInfo: '=?', schedulerApi: '=?'},
        transclude: true,
        templateUrl: 'app/components/eyeson/scheduler/eyeson.scheduler.template.html',

        link: function ($scope, $element, $attrs, $controller) {
            $timeout(function () {
                var scheduleIsLoaded = false;
                var eventsInited = false;
                //console.log($scope.schedulerApi);
                $scope.schedulerApi.refreshScheduler = refreshScheduler;
                //adjust size of a scheduler
                $scope.$watch(function () {
                    return $element[0].offsetWidth + "." + $element[0].offsetHeight;
                }, function () {
                    scheduler.setCurrentView();
                });
                $scope.$watch('timingInfo', function (timingInfo) {

                    //console.log(" $scope.$watch('timingInfo', function (timingInfo) ");
                    regenerateEvents(timingInfo);

                });

                initSchedule();
            }, 0);

            function refreshScheduler() {
                //   alert('refresh called');
                regenerateEvents($scope.timingInfo);
            }

            function regenerateEvents(timingInfo) {


                scheduleIsLoaded = false;
                var first_hour = 0;
                var last_hour = 23;
                var limit_start = new Date();
                var limit_end = new Date('3000-01-01');
                if (timingInfo && timingInfo.startTime)
                    first_hour = (new Date(timingInfo.startTime)).getHours();
                if (timingInfo && timingInfo.endTime)
                    last_hour = (new Date(timingInfo.endTime)).getHours();
                if (timingInfo && timingInfo.fromDate)
                    limit_start = new Date(timingInfo.fromDate);
                if (timingInfo && timingInfo.toDate)
                    limit_end = new Date(timingInfo.toDate);
                scheduler.config.first_hour = first_hour;
                scheduler.config.last_hour = last_hour;
                scheduler.config.limit_start = limit_start;
                scheduler.config.limit_end = limit_end;
                scheduler.config.limit_view = true;


                scheduler.updateView(limit_start);


                clearSchedule();
                if (timingInfo != undefined && timingInfo.availableTimes != undefined) {
                    //adding offtimes
                    angular.forEach(timingInfo.offDates, function (date) {

                        var eid = scheduler.addMarkedTimespan({
                                days: new Date(date),
                                // end_date:    new Date(date),
                                //  type: "dhx_time_block"
                                type: "dhx_offTime_block",
                                css: "sch-offDate",
                                zones: "fullday"
                            }
                        );
                    });
                    angular.forEach(timingInfo.offDaysOfWeek, function (day) {
                        //
                        var offdays = [];
                        offdays.push(convertWeekNameToOrder(day));
                        var eid = scheduler.addMarkedTimespan({
                                days: offdays,
                                // end_date:    new Date(date),
                                //  type: "dhx_time_block"
                                type: "dhx_offTime_block",
                                css: "sch-offDate",
                                zones: "fullday"
                            }
                        );
                    });
                    angular.forEach(timingInfo.offTimes, function (time) {

                        var zones = [];
                        var startTime = new Date(time.startTime);
                        var endTime = new Date(time.endTime);
                        var startMin = startTime.getMinutes();
                        var endMin = endTime.getMinutes();

                        zones.push(startTime.getHours() * 60 + startMin);
                        zones.push(endTime.getHours() * 60 + endMin);
                        //console.log(zones);
                        var eid = scheduler.addMarkedTimespan({
                                zones: zones,
                                days: "fullweek",
                                css: "sch-offDate",
                                // end_date:    new Date(date),
                                //  type: "dhx_time_block"
                                type: "dhx_offTime_block"

                            }
                        );
                    });

                    //adding events
                    var events = [];
                    scheduleIsLoaded = false;
                    var i = 0;
                    angular.forEach(timingInfo.availableTimes, function (time) {
                        i++;
                        //
                        //var startTime=dateUtil.fromString(time.startTime);
                        //console.log('startTime:');
                        //console.log(startTime);
                        var eid = scheduler.addEvent(
                            new Date(time.startTime),
                            new Date(time.endTime),
                            time.id,   //userdata
                            time.id,
                            time
                        );
                        time.id = eid;
                        eid.readonly = true;
                        if (i == timingInfo.availableTimes.length) {
                            scheduleIsLoaded = true;
                            eventsInited = true;
                            //  alert(i+scheduleIsLoaded);
                        }
                        //    events.push(time);
                        //  console.log('event added : ' + eid);

                    });

                    scheduler.updateView(limit_start);
                    scheduleIsLoaded = true;
                }
            }

            function onEventCreated(id, e) {
                //   refreshEvents();
            }

            function onEventDeleted(id, e) {
                refreshEvents();
            }

            function onEventChanged() {
                refreshEvents();
            }

            function onEventAdded() {
                refreshEvents();
            }

            function onDoubleClick(id, e) {
                scheduler.showLightbox(id);
            }

            function refreshEvents() {

                if (scheduleIsLoaded && eventsInited) {
                    //
                    //console.log('refresh called');
                    var evs = scheduler.getEvents();
                    var evsDto = [];

                    angular.forEach(evs, function (e) {
                        //
                        //console.log(ev);
                        var newE = {

                            startTime: e.start_date,
                            endTime: e.end_date,
                            id: e.id,
                            comment: e.text,
                            discount: e.discount,
                            capacity: e.capacity,
                            enable: e.enable,
                            price: e.price
                        };
                        evsDto.push(newE);
                    });
                    $scope.timingInfo.availableTimes = evsDto;
                }

            }

            function convertWeekNameToOrder(day) {
                var index = DAYS_VALUES.indexOf(day);
                if (index == 0) return 6;
                return index - 1;

            }

            function clearSchedule() {
                scheduler.clearAll();
                scheduler.deleteMarkedTimespan();
            }

            function initSchedule() {
                //styling for dhtmlx scheduler
                $element.addClass("dhx_cal_container");

                scheduler.config.start_on_monday = false;
                scheduler.config.show_loading = true;
                //init scheduler
                //
                scheduler.templates.event_class = function (start, end, ev) {

                    if (!ev.enable) {
                        return "scheduler_not_enable";
                    }
                    if (!ev.capacity > 0) {
                        return "scheduler_no_capacity";

                    }

                    return "scheduler_available";
                }
                scheduler.init($element[0], new JDate(), "week");
                scheduler.config.icons_select = [
                    //"icon_details",
                    //
                    //"icon_delete"
                ];

                scheduler.attachEvent("onEventCreated", onEventCreated);
                scheduler.attachEvent("onEventAdded", onEventAdded);
                scheduler.attachEvent("onEventDeleted", onEventDeleted);
                scheduler.attachEvent("onEventChanged", onEventChanged);
                scheduler.attachEvent("onDblClick", onDoubleClick);
                scheduler.templates.event_text = eventTextTemplate;
                scheduler.templates.tooltip_text = eventTooltipTemplate;
                dhtmlXTooltip.config.className = 'dhtmlXTooltip tooltip';
                dhtmlXTooltip.config.timeout_to_display = 500000000;
                scheduler.config.separate_short_events = true;
                //scheduler.config.hour_size_px = 70;
                dhtmlXTooltip.config.delta_x = 15;
                dhtmlXTooltip.config.delta_y = -20;

                function eventTextTemplate(start, end, event) {
                    return '<span>' + event.text + '-' + ' </span><span style="color:#aed581"> <span  class="glyphicon glyphicon-user">  </span>' + event.capacity + '</span>';


                }

                function eventTooltipTemplate(start, end, event) {

                    if (!event.price) event.price = 0;
                    if (!event.discount) event.discount = 0;

                    var tooltipHtml = '<div class="scheduler_tooltip" >' +
                        '<p>' + event.text + '</p>' +
                        '<li> ظرفیت موجود : ' + event.capacity + '</li>' +
                        '<li> قیمت : ' + event.price + '</li>' +
                        '<li> تخفیف : ' + event.discount + '</li>' +
                        '</div>';
                    return tooltipHtml;
                };

                var lightBoxForm = document.getElementById("light_box_form");
                isShowing = false;
                scheduler.showLightbox = function (id) {

                    //console.log('dialog show');
                    var ev = scheduler.getEvent(id);
                    ev.updateEvent = function () {
                        scheduler.updateEvent(id);
                    };
                    if (!isShowing) {
                        ev.serviceItemId =
                            showCustomLightBox(ev);
                        isShowing = true;
                    }
                    //     scheduler.startLightbox(id, lightBoxForm);
                    //...'here you need to set values in the form'...
                    //document.getElementById("some_input").value = ev.text;
                }

//needs to be attached to the 'save' button
                function save_form() {
                    var ev = scheduler.getEvent(scheduler.getState().lightbox_id);
                    //...'here you need to retrieve values from the form'...
                    //ev.text = document.getElementById("some_input").value;
                    scheduler.endLightbox(true, lightBoxForm);
                }

//needs to be attached to the 'cancel' button
                function close_form(argument) {
                    scheduler.endLightbox(false, lightBoxForm);
                }

                scheduler.updateView();
            }

            function showCustomLightBox(dialogData) {

                $mdDialog.show({
                    locals: {dialogData: dialogData},
                    controller: SchedulerTimeSessionController,
                    controllerAs: '$ctrl',
                    templateUrl: 'app/components/eyeson/scheduler/eyeson.scheduler-time-session-dialog.template.html',
                    parent: angular.element(document.body),
                    targetEvent: dialogData,
                    clickOutsideToClose: true,
                    fullscreen: false// Only for -xs, -sm breakpoints.
                })
                    .then(function (ev) {

                        isShowing = false;

                    }, function () {
                        isShowing = false;
                    });
            };
            var SchedulerTimeSessionController = function ($scope, $mdDialog, dialogData, TimingInfo, $state) {
                var $ctrl = this;
                $ctrl.dialogData = {
                    id: dialogData.id,
                    price: dialogData.price,
                    capacity: dialogData.capacity,
                    enable: dialogData.enable,
                    discount: dialogData.discount
                };
                //
                var startDate = new JDate(dialogData.start_date);
                var endDate = new JDate(dialogData.end_date);
                $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
                if (startDate && endDate) {
                    $ctrl.title = startDate.format('dddd DD MMMM ') + '-' + 'ساعت' +
                        startDate.format('HH:SS') + ' - ' + endDate.format('HH:SS');


                }


                $ctrl.hideDialog = function () {
                    $mdDialog.hide();
                };

                $ctrl.cancelDialog = function () {
                    $mdDialog.cancel();
                };

                $ctrl.gotoNewReserve = function (serviceItemId) {
                    $mdDialog.hide();
                    $state.go('supplierPanel.orderBagWithParameter', {
                        serviceItemId: serviceItemId,
                        timeSessionId: dialogData.id
                    });

                }
                $ctrl.gotoOrderBag = function (id) {
                    $mdDialog.hide();
                    $state.go('supplierPanel.editOrderBag', {id: id});

                }
                $ctrl.changeEnable = function (data) {
                    TimingInfo.changeTimeSessionEnable(data.id).get(function () {
                        $ctrl.dialogData.enable = !$ctrl.dialogData.enable;
                        dialogData.enable = $ctrl.dialogData.enable;
                        dialogData.updateEvent();
                    });
                }
                $ctrl.saveDialog = function (answer) {
                    dialogData.price = $ctrl.dialogData.price;
                    dialogData.discount = $ctrl.dialogData.discount;
                    dialogData.capacity = $ctrl.dialogData.capacity;
                    dialogData.enable = $ctrl.dialogData.enable;
                    dialogData.updateEvent();
                    $mdDialog.hide(answer);
                };
            }
            SchedulerTimeSessionController.$inject = ['$scope', '$mdDialog', 'dialogData', 'TimingInfo', '$state'];


        }//end of link method
    }
}]);
